import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ConfigurationServices } from '../../../configuration/services';

/**
 * Generated class for the MenuTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-tutorial-slide',
  templateUrl: 'configuration-tutorial-slide.html',
})
export class ConfigurationTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public configurationServices: ConfigurationServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_configuration = true;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_configuration': this.globals.restaurant.tutorial_configuration,
    }).then(() => {
      this.navCtrl.pop();
    });
  }

  closeLeave() {
    this.globals.restaurant.tutorial_configuration = true;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_configuration': this.globals.restaurant.tutorial_configuration,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/configuration-tutorial-slide/configuration-tutorial-slide.ts